import React from "react"
import { httpClient } from "../../helper/utils";
import { Constant } from "../../helper/constant";

/**
 * @param {string} keyword
 * @param {Omit<RequestInit, "method" | "headers">} [requestInit]
 */
export async function getSupplierAutocomplete(keyword, requestInit) {
  const token = localStorage.getItem("token")
  const response = await httpClient(
    `${Constant.BASE_API_URL}/supplier/autocomplete?keyword=${keyword}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      ...requestInit,
    }
  );
  return response.json();
}

export function useSupplierAutocomplete(keyword, shouldFetch = true) {
  const [data, setData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [isError, setIsError] = React.useState(false)

  React.useEffect(() => {
    if (!shouldFetch) return

    if (!keyword || keyword.length < 2) {
      setData([])
      setIsLoading(false)
      setIsError(false)
      return
    }

    const controller = new AbortController()

    async function fetchData() {
      setIsLoading(true)
      try {
        const response = await getSupplierAutocomplete(keyword, {
          signal: controller.signal
        })
        setData(response.data.supplier)
        setIsLoading(false)
      } catch (error) {
        if (error.name !== "AbortError") {
          setData([])
          setIsError(true)
        }
        setIsLoading(false)
      }
    }

    fetchData()
  }, [keyword, shouldFetch])

  return {
    data,
    isLoading,
    isError,
  }
}
